"use client"
import { Box, Tooltip } from "@mantine/core"
import classes from "./styles/CollapsedWebPhone.module.css"
import { IconChevronCompactLeft } from "@tabler/icons-react"
import { useMediaQuery, useOs } from "@mantine/hooks"
import { useAppStoreContext } from "@/stores/appStore"
import { useTranslations } from "next-intl"

interface ICollapsedWebPhoneProps {
  isPopup?: boolean
}

export function CollapsedWebPhone({ isPopup }: ICollapsedWebPhoneProps) {
  const os = useOs()
  const isBigEnough = useMediaQuery("(min-width: 48em)")
  const { webphoneExpanded: expanded, setWebphoneExpanded } = useAppStoreContext((s) => s)
  const t = useTranslations("webphone")

  if (isPopup) return null
  if (expanded || (!expanded && !isBigEnough)) return null

  return (
    <Box className={classes.container} onClick={() => setWebphoneExpanded(true)}>
      <Box className={classes.wrapper}>
        <Box className={classes.bgContainer} />
        <Box className={classes.iconContainer}>
          <Tooltip
            label={t("tooltips.show", {
              shortcut: os === "macos" ? "⌘ + P" : "Ctrl + P",
            })}
            position="left"
          >
            <Box className={classes.buttonContainer}>
              <IconChevronCompactLeft size={24} />
            </Box>
          </Tooltip>
        </Box>
      </Box>
    </Box>
  )
}
